import Header from './components/Header';
import Hero from './components/Hero';
import ContactSection from './components/ContactSection';
import FocusTopicsSection from './components/FocusTopicsSection';
import TopicIndexSection from './components/TopicIndexSection';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import AppEntrySection from './components/AppEntrySection';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import FAQSection from './components/FAQSection';
import InfoCardsSection from './components/InfoCardsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <ContactSection />
        <FocusTopicsSection />
        <TopicIndexSection />
        <AboutSection />
        <UpdatesSection />
        <TopicsSection />
        <FeaturesSection />
        <AppEntrySection />
        <CommentsSection />
        <MediaSection />
        <RankingSection />
        <FAQSection />
        <InfoCardsSection />
      </main>
      <Footer />
    </>
  );
}